import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'

loadFonts()

if (!Array.prototype.at) {
  Array.prototype.at = function (index) {
    return this[index < 0 ? this.length + index : index];
  };
}


createApp(App)
  .use(router)
  .use(store)
  .use(vuetify)
  .mount('#app')
